import { VariantColor } from '@repo/toolkit/colors'

export enum UserTypeEnum {
  CLIENT = 'CLIENT',
  STAFF = 'STAFF',
  OL = 'OL'
}

export const userTypeEnumMapping: Record<UserTypeEnum, { label: string; variant: VariantColor }> =
  {
    [UserTypeEnum.CLIENT]: {
      label: 'Client',
      variant: 'darkBlue'
    },
    [UserTypeEnum.STAFF]: {
      label: 'Encadrant',
      variant: 'blue'
    },
    [UserTypeEnum.OL]: {
      label: 'Prestataire',
      variant: 'purple'
    }
  }
